<template>
  <div class="footer-con">
    <div class="left">
      <div class="name">
        <img class="logo" src="../assets/homePage/logoWhite.png"/>
      </div>
      <div class="address">地址：沈阳市浑南区营盘北街3号409、410室</div>
      <div class="phone">电话：024-22592835</div>
      <div class="copyright">玖聚 © 辽宁玖聚律师事务所 辽ICP备2025064673号</div>
    </div>
    <div class="right">
      <div class="qrcode">
        <!-- 替换为实际二维码图片路径 -->
        <img src="../assets/homePage/ercode.png" alt="企业微信二维码">
      </div>
      <div class="qrcode-text">企业微信</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'Footer',
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="scss">
.footer-con {
  width: 100%;
  background-color: #121212; /* 深蓝色背景，接近图片色调 */
  padding: 72px 10vw; /* 左右留白与页面其他部分一致 */
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.85); /* 浅白色文字，保证可读性 */
  display: flex;
  justify-content: space-between; /* 左右两部分分开 */
  align-items: center; /* 垂直居中对齐 */

  .left {
    display: flex;
    flex-direction: column;
    gap: 12px; /* 文本行间距 */

    .address, .phone, .copyright {
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 1.6;
    }

    .copyright {
      margin-top: 8px;
      color: rgba(255,255,255,0.5);
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: center; /* 二维码和文字居中 */
    gap: 10px;

    .qrcode {
      width: 140px;
      height: 140px;
      background-color: #FFFFFF; /* 二维码白色背景 */
      padding: 8px;
      border-radius: 4px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .qrcode-text {
      font-weight: 400;
      font-size: 14px;
      color: rgba(255,255,255,0.5);
    }
  }
}

/* 响应式适配 - 小屏幕下堆叠显示 */
@media (max-width: 768px) {
  .footer-con {
    flex-direction: column;
    gap: 30px;
    padding: 50px 10vw;
    text-align: center;
  }

  .left .firm-name {
    justify-content: center;
  }
}
</style>
